import React, { useEffect, useState } from "react";
import { Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getUserMessage } from "../../redux/UserActions";
import ChatInfo from "./ChatInfo";
import UserMessages from "./UserMessages";
import ChatInput from "./ChatInput";

export default function Chat(props) {
  const userSelector = useSelector((state) => state.user);
  const dispatch = useDispatch();

  const [chat, setChat] = useState({});
  const [selectedUser, setSelectedUser] = useState("");

  useEffect(() => {
    setChat(userSelector.currentConversation);
  }, [userSelector.currentConversation]);

  useEffect(() => {
    setSelectedUser(props.selected);
  }, [props.selected]);

  useEffect(() => {
    if (selectedUser !== chat?.caseId) {
      setChat({});
    }
    if (selectedUser !== "") {
      dispatch(
        getUserMessage({
          caseId: selectedUser,
        })
      );
      const interval = setInterval(() => {
        dispatch(
          getUserMessage({
            caseId: selectedUser,
          })
        );
      }, 5000);
      return () => clearInterval(interval);
    }
  }, [selectedUser]);

  return (
    <>
      {chat && Object.keys(chat).length != 0 ? (
        <div
          className={
            "relative flex flex-col w-full " +
            (props.expanded ? "lg:mr-96" : "lg:mr-16")
          }
        >
          <ChatInfo
            chat={chat}
            caseId={chat.caseId}
            firstName={
              chat?.people[0]?._id["$oid"] != userSelector.user._id
                ? chat.people[0]?.firstName
                : chat.people[1].firstName
            }
            lastName={
              chat?.people[0]?._id["$oid"] != userSelector.user._id
                ? chat.people[0].lastName
                : chat.people[1].lastName
            }
            countryCode={
              chat?.people[0]?._id["$oid"] != userSelector.user._id
                ? chat.people[0].countryCode
                : chat.people[1].countryCode
            }
            phoneNumber={
              chat?.people[0]?._id["$oid"] != userSelector.user._id
                ? chat.people[0].phoneNumber
                : chat.people[1].phoneNumber
            }
            profilePicture={
              chat?.people[0]?._id["$oid"] != userSelector.user._id
                ? chat.people[0]?.profilePicture
                : chat.people[1].profilePicture
            }
          />

          <UserMessages messages={chat?.messages} />

          <ChatInput caseId={chat.caseId} status={chat.status} />
        </div>
      ) : null}
    </>
  );
}
